export const SET_SELECTED_PATIENT = 'SET_SELECTED_PATIENT';
